import { render, staticRenderFns } from "./folder-files-filters-modal.vue?vue&type=template&id=797a0960&scoped=true"
import script from "./folder-files-filters-modal.vue?vue&type=script&lang=js"
export * from "./folder-files-filters-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a0960",
  null
  
)

export default component.exports